export default {"src":"/_next/static/media/fire-smart-maximum.c53512f8.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};